import { render, staticRenderFns } from "./RsaConfigurazioneAreeListComponent.vue?vue&type=template&id=33bd38db"
import script from "./RsaConfigurazioneAreeListComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneAreeListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports